import { call, put, takeEvery } from "redux-saga/effects";
import { BLOCK_PROFILE, GET_ASTRO_BALANCE, GET_HOROSCOPE_MATCH, MESSAGE_THREAD, SENT_MESSAGE } from "./ActionTypes";
import { blockProfileApiError, blockProfileSuccess, getAstroBalanceApiError, getAstroBalanceSuccess, getHoroscopeMatchApiError, getHoroscopeMatchSuccess, getMessageApiError, getMessageSuccess, sentMessageApiError, sentMessageSuccess } from "./Action";
import { Block_profile, Get_Astro_Balance, Get_Horoscope_Match, Message_Thread, Sent_Message } from "../../Helpers/api_helpers";
import Constants from "../../Constants/constants";
import { Unblock_profile } from "../../Helpers/api_helpers";


function* getMessageData({ payload: { data, id, email, type, notificationId, messageTypeId, kmcareId  } }) {
  
  try {
    const response = yield call(Message_Thread,{
      threadId:data,
      status:type,
      email:email ?? null,
      userId: id,
      notificationId: notificationId ?? undefined,
      messageTypeId : messageTypeId ?? undefined, 
      kmcareId : kmcareId ?? undefined,
    });
    if (response.data.status === "Success") {
      yield put(getMessageSuccess(response));
    } else {
      yield put(getMessageApiError(response));
    }
  } catch (error) {
    yield put(getMessageApiError(error));
  }
}


function* sentMessageData({ payload: { id, email, msg, toProfileId, notificationId } }) {
  try {
    const response = yield call(Sent_Message,{
      toProfileId:toProfileId,
      email:email,
      message:msg.message,
      notificationId: notificationId ?? undefined,
      userId:id,
      ...msg.requestTypes
    });
    if (response.data.status === "Success") {
      yield put(sentMessageSuccess(response));
    } else {
      yield put(sentMessageApiError(response));
    }
  } catch (error) {
    yield put(sentMessageApiError(error));
  }
}

function* blockProfile({ payload: {status, toProfileId} }) {
  try {
    const response = yield call(status == 0 ? Unblock_profile : Block_profile,{
      toProfileId:toProfileId,
      email:localStorage.getItem(Constants.loginLocalStorageKeys.loginEmail) == '' ? null: localStorage.getItem(Constants.loginLocalStorageKeys.loginEmail),
      userId:localStorage.getItem(Constants.loginLocalStorageKeys.loginId)
    });
    if (response.data.status === "Success") {
      yield put(blockProfileSuccess(response));
    } else {
      yield put(blockProfileSuccess(response));
    }
  } catch (error) {
    yield put(blockProfileApiError(error));
  }
}

function* astroBalance() {
  try {
    const response = yield call(Get_Astro_Balance);
    if (response.data.status === "Success") {
      yield put(getAstroBalanceSuccess(response));
    } else {
      yield put(getAstroBalanceSuccess(response));
    }
  } catch (error) {
    yield put(getAstroBalanceApiError(error));
  }
}

function* horoscopeMatch({ payload: { toProfileId} }) {
  try {
    const response = yield call(Get_Horoscope_Match,toProfileId);
    if (response.data.status === "Success") {
      yield put(getHoroscopeMatchSuccess(response));
    } else {
      yield put(getHoroscopeMatchSuccess(response));
    }
  } catch (error) {
    yield put(getHoroscopeMatchApiError(error));
  }
}



function* conversationSaga() {
  yield takeEvery(MESSAGE_THREAD, getMessageData);
  yield takeEvery(SENT_MESSAGE, sentMessageData);
  yield takeEvery(BLOCK_PROFILE, blockProfile);
  yield takeEvery(GET_ASTRO_BALANCE, astroBalance)
  yield takeEvery(GET_HOROSCOPE_MATCH, horoscopeMatch)
}

export default conversationSaga;
